import React, { Component } from "react";
import PropTypes from "prop-types";
import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";
import { formatNumber, shouldHideField } from "../../../utils/numberFormatting";

import { isDefined, functor, getMALabel } from "../utils";
import { getSourcePathLabel } from "../utils/getSourcePath";
import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";

class PriceOscillatorTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const {
      onClick,
      fontFamily,
      fontSize,
      yAccessor,
      displayFormat,
      className,
    } = this.props;
    const { options, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;
    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const priceOsc = isDefined(currentItem) && yAccessor(currentItem);
    const value = (priceOsc && displayFormat(priceOsc)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Hide tooltip if value is n/a
    if (shouldHideField(value)) {
      return null;
    }

    // Use displayName if provided (e.g., "Price Osc(12,26,EMA,EMA(10))"), otherwise build from options
    let tooltipLabel;
    if (options.displayName) {
      // Use pre-computed displayName (handles series sources correctly)
      tooltipLabel = `${options.displayName}: `;
    } else {
      // Fallback: build from options
      const sourcePath = options.sourcePath || "close";
      const sourceLabel = getSourcePathLabel(sourcePath);
      const maType = options.movingAverageType || "ema";
      const maLabel = getMALabel(maType);
      const mode = options.mode || "Percent";
      const modeLabel = mode === "Percent" ? "%" : "pts";
      tooltipLabel = `Price Osc (${options.shortPeriod},${options.longPeriod},${maLabel},${sourceLabel},${modeLabel}): `;
    }

    // Add suffix based on mode
    const mode = options.mode || "Percent";
    const suffix = mode === "Percent" ? "%" : "";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-price-oscillator"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>{tooltipLabel}</ToolTipTSpanLabel>
          <tspan fill={textFill}>
            {value}
            {suffix}
          </tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

PriceOscillatorTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  options: PropTypes.shape({
    shortPeriod: PropTypes.number.isRequired,
    longPeriod: PropTypes.number.isRequired,
    sourcePath: PropTypes.string,
    movingAverageType: PropTypes.string,
    mode: PropTypes.string,
    displayName: PropTypes.string, // Pre-computed display name
  }).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  displayFormat: PropTypes.func.isRequired,
  displayValuesFor: PropTypes.func,
  textFill: PropTypes.string,
  labelFill: PropTypes.string,
};

PriceOscillatorTooltip.defaultProps = {
  displayFormat: (d) => formatNumber(d, 2),
  displayValuesFor: displayValuesFor,
  origin: [0, 0],
  className: "react-stockcharts-tooltip",
};

export default PriceOscillatorTooltip;
